// O vocabulário do operador — UM arquivo. Botões, avisos e a mensagem do grupo do
// WhatsApp dizem as mesmas palavras ("Fazendo" / "Feito", as da mensagem do grupo).
// Trocar para "Começar" / "Terminei" depois é mudar uma linha aqui.

export const ROTULO_INICIAR = "Fazendo";
export const ROTULO_CONCLUIR = "Feito";
export const AVISO_CONCLUIDO = "Feito";
export const ROTULO_DESFAZER = "Desfazer";

/** O "Feito · Desfazer" fica na tela por este tempo. */
export const SEGUNDOS_DO_AVISO_DE_DESFAZER = 8;

/** Títulos de seção da mensagem do lembrete no grupo. */
export const SECAO_FAZENDO = "Fazendo";
export const SECAO_NA_FILA = "Na fila";
export const SECAO_FEITO = "Feito";
